export const fonts = {
  body: `myriad-pro, sans-serif`,
  heading: `marvin, sans-serif`
};
